import { privateRequest } from "../../axios";


const ENDPOINTS = {
    ORDER_DETAILS : "/api/OrderMaster/GetOrders",
    ADD_ORDERS : "/api/OrderMaster/AddOrder",
    PRODUCT_INVENTORY_LIST : "/api/ProductInventory/getProducts",
    DISTRIBUTOR_PRODUCT_LIST : "/api/DistributorManufactureProducts",
    DISTRIBUTOR_MANAFAUTER_LIST : "/api/DistributorManufactureProducts/Manufacturer/Products"
}

const getPurchaseOrder = async (params: any) => {
  const response = await privateRequest.post(`${ENDPOINTS.ORDER_DETAILS}?from=${params.from}&to=${params.to}&search=${params.search}&status=${params.status}&fromDate=${params.fromDate}&toDate=${params.toDate}`);
  return response?.data;
};

const addRetailerOrder = async(payload : any) => {
    const res = await privateRequest.post(ENDPOINTS.ADD_ORDERS,payload);
    return res?.data;
}

const getproductInventoryList = async(distributorId : any) => {
    const res = await privateRequest.get(`${ENDPOINTS.PRODUCT_INVENTORY_LIST}/${distributorId}`);
    return res?.data;
}

const getSpecificRetailerOrder = async(orderId : any) => {
    const res = await privateRequest.post(`${ENDPOINTS.ORDER_DETAILS}/${orderId}`);
    return res?.data;
}

const getDistributorProductList = async (params: any) => {
  const response = await privateRequest.get(`${ENDPOINTS.DISTRIBUTOR_PRODUCT_LIST}?distributorId=${params.distributorId}&from=${params.from}&to=${params.to}&search=${params.search}`);
  return response?.data;
};

const getDistributormfcProductList = async () => {
  const response = await privateRequest.get(ENDPOINTS.DISTRIBUTOR_MANAFAUTER_LIST);
  return response?.data;
};


const AllOrdersService = {
    getPurchaseOrder,
    addRetailerOrder,
    getproductInventoryList,
    getSpecificRetailerOrder,
    getDistributorProductList,
    getDistributormfcProductList
}

export default AllOrdersService;